import "./chunk-BUSYA2B4.js";
const Headers = {
  NextRewrite: "x-middleware-rewrite",
  NextResume: "x-middleware-next",
  NextRedirect: "Location",
  // Used by next to identify internal navigation for app router
  NextUrl: "next-url",
  NextAction: "next-action",
  // Used by next to identify internal navigation for pages router
  NextjsData: "x-nextjs-data"
};
const constants = {
  Headers
};
export {
  constants
};
//# sourceMappingURL=constants.js.map